<template>
  <div class="itemshop-root">
    <img src="@/assets/ui/itemshop/shop-bg.png" class="shop-bg" draggable="false" />

    <!-- 顶部标题栏 -->
    <div class="shop-header">
      <span class="shop-title">道具商城</span>
      <button @click="$emit('changeView', 'UserHomeMain')" class="close-btn">×</button>
    </div>

    <!-- 主内容区 -->
    <div class="shop-content">
      <!-- 道具列表 -->
      <div class="item-list-scroll">
        <div class="item-list">
          <div 
            v-for="item in items"
            :key="item.item_id"
            class="item"
            :class="{ selected: selectedItem && selectedItem.item_id === item.item_id }"
            @click="selectItem(item)"
            @mouseenter="hoveredItem = item.item_id"
            @mouseleave="hoveredItem = null"
            :style="{ transform: hoveredItem === item.item_id ? 'scale(1.08)' : '' }"
            ref="itemRefs"
          >
            <div class="item-frame">
              <img :src="item.icon_path" :alt="item.external_name" />
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧道具详情 -->
      <transition name="fade">
        <div class="item-details" v-if="selectedItem" ref="itemDetails">
          <div class="details-frame">
            <img :src="selectedItem.icon_path" :alt="selectedItem.external_name" class="details-img" />
          </div>
          <div class="details-text">
            <h3>{{ selectedItem.external_name }}</h3>
            <p class="price-line">
              价格: <span class="price">{{ selectedItem.price }}</span> 金币
            </p>
            <p>效果: <span>{{ selectedItem.effect_description }}</span></p>
            <button class="buy-btn" @click="openPurchaseModal">购买</button>
          </div>
        </div>
      </transition>
    </div>

    <!-- 购买弹窗 -->
    <transition name="fade">
      <div class="modal-mask" v-if="showModal">
        <div class="modal-content" ref="modalContent">
          <h3>确认购买</h3>
          <img :src="selectedItem.icon_path" alt="道具图标" class="modal-img" />
          <p>名称: {{ selectedItem.external_name }}</p>
          <label for="quantity" class="quantity-label">选择数量:</label>
          <input 
            type="number" 
            v-model.number="purchaseQuantity" 
            min="1"
            class="quantity-input"
          />
          <div class="modal-buttons">
            <button class="confirm-btn" @click="confirmPurchase">确认</button>
            <button class="cancel-btn" @click="closePurchaseModal">取消</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- 通知 -->
    <transition name="fade">
      <div class="notification" v-if="notification.message" ref="notification">
        <span :class="notification.type">{{ notification.message }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import { enterAnimation, exitAnimation, hoverAnimation, fadeInUp } from './shopAnimations';

export default {
  data() {
    return {
      items: [],
      selectedItem: null,
      hoveredItem: null,
      showModal: false,
      purchaseQuantity: 1,
      notification: { message: '', type: '' }
    };
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
      if (this.$refs.itemDetails) enterAnimation(this.$refs.itemDetails);
    },
    openPurchaseModal() {
      this.showModal = true;
      this.$nextTick(() => {
        if (this.$refs.modalContent) enterAnimation(this.$refs.modalContent);
      });
    },
    closePurchaseModal() {
      if (this.$refs.modalContent) {
        exitAnimation(this.$refs.modalContent, () => {
          this.showModal = false;
        });
      } else {
        this.showModal = false;
      }
    },
    confirmPurchase() {
      const userId = this.$getUserId();
      this.$axios.post('/shop/buy', {
        userId,
        itemId: this.selectedItem.item_id,
        quantity: this.purchaseQuantity
      }).then(() => {
        this.notification = { message: '购买成功！', type: 'success' };
        fadeInUp(this.$refs.notification);
        this.closePurchaseModal();
      }).catch(error => {
        if (error.response && error.response.data.error === 'Not enough coins') {
          this.notification = { message: '金币不足！', type: 'error' };
        } else {
          this.notification = { message: '购买失败，请重试。', type: 'error' };
        }
        fadeInUp(this.$refs.notification);
        this.closePurchaseModal();
      });
    },
  },
  mounted() {
    this.$axios.get('/shop/items').then(response => {
      this.items = response.data;
      if (this.items.length > 0) {
        this.selectedItem = this.items[0];
      }
    }).catch(error => {
      console.error('Error fetching shop items:', error);
    });

    this.$nextTick(() => {
      hoverAnimation(this.$refs.itemRefs);
    });
  },
};
</script>

<style scoped>
.itemshop-root {
  position: fixed;
  inset: 0;
  width: 100vw; height: 100vh;
  min-width: 300px; min-height: 250px;
  display: flex; flex-direction: column;
  align-items: center; justify-content: flex-start;
  background: #e3f2fd;
  overflow: hidden;
  z-index: 1900;
}
.shop-bg {
  position: absolute; left: 0; top: 0; width: 100vw; height: 100vh;
  object-fit: cover; z-index: 0; pointer-events: none; user-select: none;
}
.shop-header {
  width: 100%; max-width: 700px;
  height: 50px;
  display: flex; align-items: center; justify-content: space-between;
  background: rgba(62,148,255,0.97);
  color: #fff;
  font-size: 1.2rem; font-weight: bold;
  padding: 0 24px; margin: 0 auto; border-radius: 0 0 19px 19px;
  box-shadow: 0 2px 16px #134aad24;
  z-index: 2; position: relative;
}
.shop-title { font-size: 1.12em; letter-spacing: 0.09em;}
.close-btn {
  background: rgba(255,255,255,0.13);
  color: #fff; font-size: 1.65em; border: none; border-radius: 50%;
  cursor: pointer; padding: 0 14px; font-weight: bold;
  transition: background .17s;
}
.close-btn:hover { background: rgba(255,255,255,0.35);}
.shop-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 96vw;
  max-width: 700px;
  min-width: 260px;
  height: auto;
  max-height: 90vh;
  min-height: 260px;
  background: rgba(255,255,255,0.10);
  border-radius: 20px;
  box-shadow: 0 8px 32px #176dd120;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  gap: 20px;
  z-index: 2;
  padding: clamp(8px,2vw,22px) clamp(8px,2vw,22px) 0;
  box-sizing: border-box;
  overflow: hidden;
}

/* 左侧道具栏，滚动且自动自适应4格正方形 */
.item-list-scroll {
  flex: 2 2 0; min-width: 0; max-width: 380px;
  height: auto;
  max-height: 65vh;  /* 关键：限制道具列表高度，溢出可滚动 */
  background: rgba(255,255,255,0.77); border-radius: 15px;
  padding: 12px 9px 12px 9px; overflow-y: auto; box-sizing: border-box;
  box-shadow: 0 2px 11px #2a8ed51a;
  display: flex; flex-direction: column; justify-content: flex-start;
}
.item-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
@media (max-width: 800px) {
  .shop-header, .shop-content { max-width: 99vw; }
  .item-list-scroll { max-width: 48vw; }
}
@media (max-width: 600px) {
  .shop-content { gap: 7px; padding: 5px 1vw 0;}
  .item-list-scroll { padding: 7px 3px; }
  .item-list { gap: 7px; }
}
@media (max-width: 460px) {
  .item-list-scroll { max-width: 99vw; }
  .item-list { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 370px) {
  .item-list { grid-template-columns: repeat(2, 1fr);}
}

/* 道具单元格 */
.item {
  aspect-ratio: 1/1;
  border-radius: 11px;
  background: #f3fbff;
  box-shadow: 0 2px 6px #3296ff19;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; position: relative;
  border: 2.1px solid transparent;
  transition: transform 0.25s cubic-bezier(.3,.7,.4,1.2), border-color 0.18s;
}
.item.selected, .item:hover { border-color: #25c1ff; z-index: 2;}
.item-frame { width: 90%; height: 90%; display: flex; align-items: center; justify-content: center;}
.item img { width: 85%; height: 85%; object-fit: contain; }

/* 右侧详情区 */
.item-details {
  flex: 1 1 0; min-width: 0;
  margin-left: 2vw;
  background: rgba(255,255,255,0.94);
  border-radius: 14px;
  box-shadow: 0 3px 15px #0074f718;
  padding: 18px 17px;
  display: flex; flex-direction: column; align-items: center;
  animation: fadeInUp 0.38s cubic-bezier(.43,.7,.4,1.22);
}
.details-frame {
  width: 75px; height: 75px; background: #eef7fd; border-radius: 13px;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 10px; box-shadow: 0 2px 12px #b6f8ff22;
}
.details-img { width: 74%; height: 74%; object-fit: contain; }
.details-text { width: 100%; text-align: left;}
.item-details h3 {
  margin: 0 0 7px 0;
  font-size: 1.17em; font-weight: bold; color: #28497e;
}
.price-line { font-size: 1.05em; margin-bottom: 7px;}
.price { color: #ff7043; font-weight: bold;}
.buy-btn {
  padding: 8px 22px; margin-top: 14px; background: linear-gradient(90deg,#ff5722,#ffc107 80%);
  color: #fff; border: none; border-radius: 7px; font-size: 1.08em;
  font-weight: bold; cursor: pointer; box-shadow: 0 1px 8px #ff704338;
  transition: background 0.18s;
}
.buy-btn:hover { background: linear-gradient(90deg,#ff7847,#ffb736 90%);}

/* 弹窗 */
.modal-mask {
  position: fixed; inset: 0;
  background: rgba(39,66,140,0.21);
  z-index: 4000;
  display: flex; align-items: center; justify-content: center;
}
.modal-content {
  background: #fff;
  border-radius: 13px;
  box-shadow: 0 7px 22px #254b881a;
  padding: 26px 18px 16px 18px;
  display: flex; flex-direction: column; align-items: center;
  animation: fadeInUp 0.32s cubic-bezier(.4,.7,.4,1.12);
  min-width: 220px; max-width: 90vw;
}
.modal-img { width: 60px; height: 60px; margin-bottom: 10px;}
.quantity-label { font-size: 0.98em; color: #1976d2; }
.quantity-input { width: 70px; margin-top: 9px; text-align: center;}
.modal-buttons { display: flex; gap: 16px; margin-top: 18px;}
.confirm-btn {
  background: #23cd62; color: #fff; border: none; padding: 9px 22px;
  border-radius: 7px; font-weight: bold; font-size: 1.05em; cursor: pointer;
  box-shadow: 0 2px 8px #45ef7722;
}
.cancel-btn {
  background: #d32f2f; color: #fff; border: none; padding: 9px 22px;
  border-radius: 7px; font-weight: bold; font-size: 1.05em; cursor: pointer;
  box-shadow: 0 2px 8px #f7636322;
}

/* 通知 */
.notification {
  position: fixed;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 13px 29px;
  border-radius: 12px;
  box-shadow: 0 4px 13px #0d92f433;
  font-size: 1.07rem;
  font-weight: bold;
  color: #333;
  z-index: 5200;
  animation: fadeInUp 0.36s cubic-bezier(.4,0,.2,1);
}
.notification.success { color: #22b868;}
.notification.error { color: #e03a3a;}

.fade-enter-active, .fade-leave-active {
  transition: opacity .28s cubic-bezier(.4,0,.2,1);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
@keyframes fadeInUp {
  0% { opacity: 0; transform: translateY(44px);}
  100% { opacity: 1; transform: translateY(0);}
}

/* 适配极端分辨率与小屏幕 */
@media (max-width: 600px) {
  .shop-content { flex-direction: column; gap: 5px;}
  .item-list-scroll { max-width: 99vw; }
  .item-details { margin-left: 0; margin-top: 8px;}
}
@media (max-width: 410px), (max-height: 390px) {
  .details-frame { width: 37px; height: 37px;}
  .details-img { width: 70%; height: 70%;}
  .modal-content { min-width: 110px;}
}

</style>
